import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const RevenueReportingSelectPaymentInfo: React.FC = () => (
  <span className={cssExports.formControlDescription}>
    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.RevenueReporting.SelectPaymentMethodInfo)}
  </span>
);

export default RevenueReportingSelectPaymentInfo;
